import { Injectable } from '@angular/core';
import { ICostCenterGroup } from '../models/cost-center-group.model';
import { CostAccountingRequestService } from '../services/cost-accounting-request.request.service';
import { Observable } from 'rxjs';

const BASE_URL: string = 'cost-center-group';

@Injectable({
    providedIn: 'root',
})
export class CostCenterGroupResource {
    constructor(private myCostAccountingRequestService: CostAccountingRequestService) {
    }

    public getAllCostCenterGroups(): Observable<ICostCenterGroup[]> {
        return this.myCostAccountingRequestService.get(BASE_URL);
    }

    public createCostCenterGroup(costCenterGroup: ICostCenterGroup): Observable<ICostCenterGroup> {
        return this.myCostAccountingRequestService.post(BASE_URL, costCenterGroup);
    }

    public updateCostCenterGroup(costCenterGroup: ICostCenterGroup): Observable<ICostCenterGroup> {
        return this.myCostAccountingRequestService.patch(`${BASE_URL}/${costCenterGroup.id}`, costCenterGroup);
    }

    public deleteCostCenterGroup(groupId: number): Observable<void> {
        return this.myCostAccountingRequestService.delete(`${BASE_URL}/${groupId}`);
    }
}
